module.exports = __webpack_public_path__ + "img/serre-toi-hero-thumb.2bfa403f.png";